import React, { CSSProperties } from "react";
interface IAlertProps {
  alert?: string;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  style?: CSSProperties;
}

const AlertBox: React.FC<IAlertProps> = ({
  alert = "No data found.",
  color = "#ae3b3e",
  backgroundColor = "#F8D7DA",
  borderColor = "#F5C2C7",
  style,
}) => {
  return (
    <div
      style={{
        marginTop: 10,
        padding: 10,
        borderRadius: 5,
        color: `${color}`,
        backgroundColor: `${backgroundColor}`,
        border: `2px solid ${borderColor}`,
        display: "flex",
        alignItems: "center",
        gap: 5,
        ...style,
      }}
    >
      {alert}
    </div>
  );
};

export default AlertBox;
